import React from "react";

export function Login() {
    return <div>Login</div>;
}
